__webpack_require__.p = "https://admin.dev.akkoooo.com/";